import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class FamilyPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.familyRead,
        );
        this.import = permissionChecker.match(
            Permissions.values.familyImport,
        );
        this.familyAutocomplete = permissionChecker.match(
            Permissions.values.familyAutocomplete,
        );
        this.create = permissionChecker.match(
            Permissions.values.familyCreate,
        );
        this.edit = permissionChecker.match(
            Permissions.values.familyEdit,
        );
        this.destroy = permissionChecker.match(
            Permissions.values.familyDestroy,
        );
    }
}